import { apiClient } from '@/lib/api/client'
import type { TasksResponse } from '@/types'

export async function getTasks(): Promise<TasksResponse> {
  return apiClient.get<TasksResponse>('/api/v2/tasks')
}
